const tenantIdentifierKey = "TenantIdentifier";

export function findTenant() {
    return window.localStorage.getItem(tenantIdentifierKey);
}
